export const PICK_ONE_PLACEHOLDER = 'Pick one';
export const NO_MATCHING_FIELDS_LABEL = 'No matching fields';
export const ALREADY_MAPPED_SUFFIX = '(Already mapped)';
